import { render, staticRenderFns } from "./UserPending.vue?vue&type=template&id=44434f41&scoped=true&"
import script from "./UserPending.vue?vue&type=script&lang=js&"
export * from "./UserPending.vue?vue&type=script&lang=js&"
import style0 from "./UserPending.vue?vue&type=style&index=0&id=44434f41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44434f41",
  null
  
)

export default component.exports